const PointLogList = [
    {id: 1, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 2, logtxt: '兑换 特种设备书02042', itype: 0, point: 158, addtime: '2025-09-28 15:40'},
    {id: 3, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 4, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 5, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 6, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 7, logtxt: '兑换 采暖设备规则0203', itype: 0, point: 58, addtime: '2025-09-28 15:40'},
    {id: 8, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
    {id: 9, logtxt: '购买TSG Z8001-2019 特种设备无损检测人员考核规则', itype: 1, point: 58, addtime: '2025-09-28 15:40'},
]


export default PointLogList